import { useCallback } from "react";
import { useAuth, ACTIONS } from "../../providers/AuthProviders";
import { useLoginMutation } from "../../api";
import { AuthLocalInput } from "../../types";

export function useLogin() {
  const { dispatch } = useAuth();
  const { mutateAsync, isPending, error, data } = useLoginMutation();

  const login = useCallback(
    async (input: AuthLocalInput) => {
      const res = await mutateAsync(input);

      const { token, user } = res.data;

      localStorage.setItem("accessToken", token);
      localStorage.setItem("currentUser", JSON.stringify(user));

      dispatch({
        type: ACTIONS.SET_AUTHENTICATED,
        payload: {
          authenticated: true,
          currentUser: user,
        },
      });

      return res;
    },
    [mutateAsync, dispatch],
  );

  return {
    login,
    loading: isPending,
    data,
    error,
  };
}
